import styled from "@emotion/styled";
import { ModalActions, modalClasses, ModalContent } from "@kaltura/ds-react-components";
import { ReactNode } from "react";
import { StyledModal } from "@kaltura/mediaspace-shared-entry/publish/publish-menu/modals/StyledModal";
import { Fade } from "@mui/material";

export interface PostRegistrationActionsModalProps {
    activeStepContent: ReactNode;
    postRegistrationActions: ReactNode;
}

export const StyledFixedHeightModal = styled(StyledModal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        height: "85vh",
        width: "790px",
        maxWidth: "790px",
        [theme.breakpoints.down("sm")]: {
            height: "100%",
        },
    },
}));

/**
 * PostRegistrationActionsModal component
 *
 * This component manages the post-registration steps for a registered user inside a modal. It displays a series of steps,
 * each represented by a component, and allows the user to navigate through them.
 * The component also handles updating and displaying step-specific messages.
 *
 */
export const PostRegistrationActionsModal = ({
    postRegistrationActions,
    activeStepContent,
}: PostRegistrationActionsModalProps) => {
    const baseClassName = "kms-ds-post-registration-modal";

    return (
        // Use "fade" transition instead of the default (zoom + fade)
        // because Truncate component in the contents doesn't work properly
        // when the CSS animation changes the size of the element
        <StyledFixedHeightModal open={true} TransitionComponent={Fade} className={`${baseClassName}`}>
            <ModalContent className={`${baseClassName}-content`}>{activeStepContent}</ModalContent>
            <ModalActions className={`${baseClassName}-actions`}>{postRegistrationActions}</ModalActions>
        </StyledFixedHeightModal>
    );
};
